import { Controller } from "@hotwired/stimulus";

// "Unsubscribe effective today" button on the LtS settings form: fills the
// end-date field with today's date. The server's date is passed via a data
// attribute so it matches Date.current regardless of the browser's timezone.
export default class extends Controller {
  static targets = ["field"];
  static values = { today: String };

  setToday() {
    this.fieldTarget.value = this.todayValue;
  }
}
